import { useEffect } from 'react';
import { anonymizePhoneNumber } from '@aviv-estimation-funnel/shells/src/app/helpers/anonymizePhoneNumber';
import { formatPhoneNumber } from '@aviv-estimation-funnel/shells/src/app/helpers/formatPhoneNumber';
import { Box } from '@gemini/core';
import { CustomEventService, IEvents } from '@mfe-helpers/customEvent';
import { composeMPUPageViewPayload } from '@mfe-helpers/tracking';
import { isFrenchPortal } from '@mfe-helpers/portalHelpers';
import Animation from '@mfe-presentation/components/Animation';
import { useAppContext } from '@mfe-presentation/contexts';
import Icon from '@mfe-presentation/components/Icon';
import { EAvCategory } from '@mfe-types/tracking';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';
import { useFormContext } from 'react-hook-form';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import PhoneNumberRequestNewCode from '@mfe-presentation/components/PhoneNumberRequestNewCode';
import PhoneNumberVerificationModal from '@mfe-presentation/components/PhoneNumberVerificationModal';

import FieldWrapper from '../Wrappers/FieldWrapper';

const PhoneNumberVerification = () => {
    const {
        formValues,
        config,
        currentStep: { name },
        userVerification,
        isFromUpdatePage,
        portal,
        useShellContext,
    } = useAppContext();
    const shellContext = useShellContext();
    const { setValue } = useFormContext();
    const { t } = useTranslation(NAME_SPACE);

    const formatedPhoneNumber = formatPhoneNumber(
        userVerification.phoneNumber || '',
        formValues.phoneNumberRegionCode,
    );

    const fields = config[name].getFields(formValues);

    useEffect(() => {
        if (isFromUpdatePage) {
            CustomEventService.fire(
                IEvents.SEND_PAGE_VIEW,
                composeMPUPageViewPayload({
                    pageTitle: 'multifactor_authentification',
                    formValues,
                    portal,
                    category: EAvCategory.Account,
                }),
            );
        }

        return () => setValue('phoneNumberVerificationCode', '');
    }, []);

    const displayedPhoneNumber = !formValues.estimationId
        ? formatedPhoneNumber
        : anonymizePhoneNumber(formatedPhoneNumber);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            testId="phone-number-verification"
        >
            <Box width="60px" height="60px">
                {/* TODO unlock animation for Immoweb on Figma. Meanwhile, we are using common/shield.svg */}
                {isFrenchPortal(portal) || portal === Portal.ImmoWeb ? (
                    <Icon width="60" height="60" name="shield-verification" />
                ) : (
                    <Animation name="shield" data={shellContext?.animations?.shield} loop={false} />
                )}
            </Box>
            <Box
                as="p"
                typography="typography.body.14.regular"
                marginBottom="spacing.8"
                color="color.content.default.default"
                textAlign="center"
            >
                {t(`step_${name}.title`)}
            </Box>
            <Box
                typography="typography.headline.28.bold"
                color="color.content.default.default"
                textAlign="center"
                marginBottom="spacing.8"
            >
                {displayedPhoneNumber}
            </Box>
            <Box
                typography="typography.body.14.regular"
                color="color.content.default.default"
                textAlign="center"
                marginBottom="spacing.8"
            >
                {t(`step_${name}.updatePhoneNumber.text`)} <PhoneNumberVerificationModal />
            </Box>
            <Box marginTop="spacing.32" marginHorizontal="spacing.none" marginBottom="spacing.none">
                <FieldWrapper
                    name="phoneNumberVerificationCode"
                    field={fields.phoneNumberVerificationCode}
                />

                <PhoneNumberRequestNewCode />
            </Box>
        </Box>
    );
};

export default PhoneNumberVerification;
